export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9268.87b4dada.jpg";